import 'jquery-migrate';
import $ from 'jquery';
import HubsEmbed from './core';
import Shared from '../shared_util';

// Bring Shared Logger to Local Object
HubsEmbed.log = Shared.Logger.log;

/**
 * HubsEmbed Application
 *
 * @class App
 * @classdesc Application Controller
 * @namespace HubsEmbed
 * @param {Object} [appOptions] Configuration Settings for the Application
 * @return {Object} The Class Instance
 * @constructor
 */
HubsEmbed.App = function(appOptions) {
    // Call Parent Constructor
    HubsEmbed.Core.apply(this, [appOptions]);

    /* **************************************************************************************** */
    /* * Private Methods/Members Declarations                                                 * */
    /* **************************************************************************************** */
    var initialize = null,
        initEvents = null;


    /* **************************************************************************************** */
    /* * Public Properties                                                                    * */
    /* **************************************************************************************** */

    /** @member {Object} $appContainer A jQuery Element Handle to the Container DIV of the Application  */
    this.$appContainer = null;

    /** @member {Object} lazyLoader A reference to the LazyLoader Object */
    this.lazyLoader = null;

    /** @member {String} uuid A Unique Idientifier for the Embedded Hub Instance */
    this.uuid = null;


    /* **************************************************************************************** */
    /* * Private Methods/Members Definitions                                                  * */
    /* **************************************************************************************** */
    /**
     * Initialize the Application
     *
     * @private
     * @this HubsEmbed.App
     * @return undefined
     * @constructs
     */
    initialize = $.proxy(function() {
        // Get App Container Element
        this.$appContainer = $(this.config.containers.app);
        if (!this.$appContainer.length) {
            return HubsEmbed.log({'msg': 'app-invalid-container', 'type': Shared.LVL_ERROR});
        }

        // Add Localization to Logger
        Shared.Logger.setL10N(Hubs.DEBUG_MSG);

        // Debug Statement
        HubsEmbed.log('app-init');

        // Get a Unique Identifier for this HubsEmbed Instance
        this.uuid = Shared.getUUID();

        // Item Container
        this.itemContainerSelector = this.config.lazyloader.elements.container.replace('#collection-items', '#collection-items[data-uuid="' + this.uuid + '"]');

        // Build DOM Elements
        this.buildElements();

        // Initialize Events
        initEvents();

        // Create LazyLoader Control for Collection Items (if exists)
        this.createLazyLoader();

        // Force-Load First Page of Content
        this.lazyLoader.loadItems(true, $.proxy(this.resizeEvent, this));

        // Add Analytics Codes for Tracking
        Shared.Tracker.addAnalyticsCodes(this.config.analyticsCodes);

        // Debug Statement
        HubsEmbed.log('app-init-end');
    }, this);

    /**
     * Initialize Events for the HubsEmbed Application
     *   - Root level events set on window object
     *
     * @private
     * @this HubsEmbed.App
     * @return undefined
     */
    initEvents = $.proxy(function() {
        var $win = Shared.$('window'),
            $moveToTop = Shared.$('#moveToTop');

        // Debug Statement
        HubsEmbed.log('events-init');

        // Window Resize/Orientation Events
        $win.on('debouncedresize.HubsEmbed.App orientationchange.HubsEmbed.App', $.proxy(this.resizeEvent, this));

        // "Move to Top" link events
        if ($moveToTop.length) {
            // Click Event for "Move to Top" link
            $moveToTop.addClass('hooked').on(Hubs.TAP_EVENT, $.proxy(function(e) {
                e.preventDefault();
                e.stopPropagation();
                $('html, body').animate({'scrollTop': 0}, 750);
                return false;
            }, this));

            // Show "Move to Top" link after scrolling a bit
            $win.scroll($.proxy(function() {
                if ($win.scrollTop() > 300) {
                    $moveToTop.addClass('show');
                } else {
                    $moveToTop.removeClass('show');
                }
            }, this));
        }
    }, this);


    /* **************************************************************************************** */
    /* * Entry Point                                                                          * */
    /* **************************************************************************************** */
    initialize();
};
HubsEmbed.App.prototype = new HubsEmbed.Core();
HubsEmbed.App.prototype.constructor = HubsEmbed.App;
// End of HubsEmbed.App


/* ******************************************************************************************** */
/* * Public Methods                                                                           * */
/* ******************************************************************************************** */

/**
 * Builds the basic DOM Elements for the Embedded Hub; no Tiles, just the container
 *
 * @private
 * @this HubsEmbed.App
 * @return undefined
 */
HubsEmbed.App.prototype.buildElements = function() {
    var html = '', classname = 'hubs-embedded';

    // Build DOM HTML
    html += '<div id="collection-items" data-uuid="' + this.uuid + '"><ul class="collection-items-container clearfix"><li id="loading-notifier" class="tile single">';
    html += '<div><img class="loading" src="' + this.config.serverUrl.cdn + 'img/hubs/ajax-loader-grey-2x.gif" width="32"></div>';
    html += '<span>Loading More Items...</span>';
    html += '</li></ul></div>';

    // Determine Tile Size class to use
    if (this.config.tileSize !== undefined) {
        classname += ' ' + this.config.tileSize + '-tiles';
    }

    // Add HTML to DOM and Update Container CSS Class
    this.$appContainer.addClass(classname).html(html);
};

/**
 * Creates the LazyLoader Control
 *
 * @public
 * @this HubsEmbed.App
 * @return undefined
 */
HubsEmbed.App.prototype.createLazyLoader = function() {
    // Create LazyLoader Control
    this.lazyLoader = new HubsEmbed.LazyLoader(this);
};

/**
 * Observes and Responds to the Resize Events fired on the Global Window Object or App Container
 *     - Also fires for the OrientationChanged event, as the behaviour is essentially the same.
 *
 * @public
 * @this HubsEmbed.App
 * @param {Object} eventData The Event Data associated with the Event
 * @return {Boolean} The success state of the event; determines whether to allow event-bubbling
 */
HubsEmbed.App.prototype.resizeEvent = function(eventData) {
    // Debug Statement
    HubsEmbed.log('app-resize');

    // Delay Event so that DOM Elements are updated
    HubsEmbed.root.setTimeout($.proxy(function() {
        var i = 0, margin = 20, maxTileDisplay = 99, tileWidth = 0, minWidth = 0, newWidth = 0,
            containerWidth = this.$appContainer.width(),
            $tile = $(this.config.lazyloader.elements.item).eq(0),
            $container = $(this.itemContainerSelector).parent();

        if (!$container.length || !$tile.length) { return; }

        // Get Max Tiles per Row
        if (this.config.lazyloader.maxTilesPerRow !== undefined && this.config.lazyloader.maxTilesPerRow > 1) {
            maxTileDisplay = this.config.lazyloader.maxTilesPerRow;
        }

        // Get Width of Tiles
        tileWidth = $tile.outerWidth();
        minWidth = tileWidth + margin;

        // Determine Best Width
        newWidth = (minWidth * maxTileDisplay);
        if (containerWidth < newWidth) {
            for (i = maxTileDisplay - 1; i >= 0; i--) {
                newWidth = (minWidth * i);
                if (containerWidth >= newWidth) { break; }
            }
        }
        if (newWidth < minWidth) { newWidth = minWidth; }

        // Update Width of Container
        $container.width(newWidth);

        // Debug Statement
        HubsEmbed.log('app-resize-end');
        HubsEmbed.Events.trigger('resize')
    }, this), 10);

    return true;
};

/**
 * Overrides all Links within the HubsEmbed Container
 *     - Hooks all Links so that behaviour can be controlled via Config settings (this.config.openLink)
 *
 * @public
 * @this Hubs.App
 * @return undefined
 */
HubsEmbed.App.prototype.overrideLinks = function() {
    // Debug Statement
    HubsEmbed.log('links-override-init');

    // Find all non-hooked internal links
    $('a[data-internal]:not([href^=mailto]):not(.hooked)').each($.proxy(function(idx, el){
        var $anchor = $(el), attr = $anchor.attr('data-internal');
        if (attr === undefined || attr === 'false') { return; }

        // Attach click event to links and mark as "hooked"
        $anchor.addClass('hooked').on(Hubs.CLICK_EVENT, $.proxy(function(e) {
            var url, $el = $(e.currentTarget), type = $el.attr('data-internal'), sourceUrl = $el.attr('data-source-url');

            // Debug Statement
            HubsEmbed.log('internal-link-click');

            // Prevent Default Action and Event Propagation
            e.preventDefault();
            e.stopPropagation();

            // Get URL
            url = $el.attr('href');
            if (Hubs.isMobile() && /uberflip/i.test(type) && sourceUrl !== undefined) {
                url = sourceUrl;
            }

            // Open Link with Config Function or Directly
            if (typeof this.config.openLink === 'function') {
                this.config.openLink(url);
            } else {
                HubsEmbed.root.location.href = url;
            }

            // Prevent Event Bubbling
            return false;
        }, this));
    }, this));

    // Find all non-hooked external sharing links
    $('a[data-share]:not(.hooked)').each($.proxy(function(idx, el){
        var $anchor = $(el), attr = $anchor.attr('data-share');
        if (attr === undefined || attr === 'false') { return; }

        // Attach click event to links and mark as "hooked"
        $anchor.addClass('hooked').on(Hubs.CLICK_EVENT, $.proxy(function(e) {
            var popupWin, popupTarget = '', $el = $(e.currentTarget), url = $el.attr('href'), type = $el.attr('data-share');

            // Debug Statement
            HubsEmbed.log('external-share-link-click');

            // Prevent Default Action
            e.preventDefault();
            e.stopPropagation();

            // Open Window for Share Service
            if (Hubs.isMobile() && type === 'email') { popupTarget = '_top'; }
            popupWin = HubsEmbed.root.open(url, popupTarget, 'left=100,top=100,width=550,height=450,personalbar=0,toolbar=0,scrollbars=1,resizable=1');

            // Force Close the Popup on Desktop
            if (!Hubs.isMobile() && type === 'email') {
                HubsEmbed.root.setTimeout(function() {
                    if (popupWin.location === undefined || popupWin.location.href === 'about:blank') {
                        popupWin.close();
                    }
                }, 1000);
            }

            // Prevent Event Bubbling
            return false;
        }, this));
    }, this));
};

/**
 * Resize a Specific Image Tile on Page
 *
 * @public
 * @this HubsEmbed.App
 * @return undefined
 */
HubsEmbed.App.prototype.resizeImageTile = function(imgEl, callback) {
    var $el        = $(imgEl).parent(),
        tileWidth  = $el.width(),
        tileHeight = $el.height(),
        $tileImg   = $el.find('img'),
        imgHeight  = $tileImg.height();

    if (imgHeight <= 0 || $tileImg.hasClass('shorter') || $tileImg.hasClass('taller')) { return; }

    // If the Image is Taller than the Tile
    if (imgHeight >= tileHeight) {
        $tileImg.addClass('taller');

        // Centering the image vertically in the tile, EXCEPT for docs, because we want to see the top of the doc in the tile
        if (!$el.parent('.tile').is('.uberflip')) {
            $tileImg.css({'margin-top' : -((imgHeight - tileHeight) / 2 )});
        }
    }

    // If the Image is Shorter than the Tile
    else {
        if (Hubs.isMobile()){
            $tileImg.css({'height' : tileHeight, 'width' : 'auto'});
        } else {
            $tileImg.addClass('shorter');
        }

        // Center the image horizontally in the tile
        $tileImg.css({'margin-left' : -(($tileImg.width() - tileWidth) / 2 )});
    }

    if (typeof callback === 'function') {
        callback.call(this);
    }
};

/**
 * Reloads the HubsEmbed App
 *
 * @public
 * @this HubsEmbed.App
 * @return undefined
 */
HubsEmbed.App.prototype.reload = function() {
    if (HubsEmbed.root._ufHubConfig === undefined) { return; }

    // Debug Statement
    HubsEmbed.log('app-reload');

    // Update Configuration Settings for Application
    this.config = $.extend(true, {}, Hubs.Config, this.config, HubsEmbed.root._ufHubConfig);

    // Reset Response Data
    HubsEmbed.root.embeddedHubsResponseData = undefined;

    // Empty Container
    this.$appContainer.empty().removeClass('hubs-embedded small-tiles medium-tiles large-tiles');

    // Build DOM Elements
    this.buildElements();

    // Reset Lazy Loader
    this.lazyLoader.reset();

    // Populate Items
    this.lazyLoader.loadItems(true, $.proxy(this.resizeEvent, this));

    // Debug Statement
    HubsEmbed.log('app-reload-end');
};
